/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BusinessLogicV1,
  BusinessLogicV1Interface,
} from "../BusinessLogicV1";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dropStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "membershipTier",
        type: "uint256",
      },
    ],
    name: "checkDropStart",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dropStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dropEnd",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "msgValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minMembershipTier",
        type: "uint256",
      },
    ],
    name: "checkMintAllowed",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "dropStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dropEnd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "msgValue",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minMembershipTier",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "membershipTier",
        type: "uint256",
      },
    ],
    name: "checkMintAllowedWithMembership",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMembershipContractAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPresaleOffset",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "membershipContractAddress",
        type: "address",
      },
    ],
    name: "setMembershipContractAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "presaleOffset",
        type: "uint256",
      },
    ],
    name: "setPresaleOffset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type BusinessLogicV1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BusinessLogicV1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BusinessLogicV1__factory extends ContractFactory {
  constructor(...args: BusinessLogicV1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BusinessLogicV1";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BusinessLogicV1> {
    return super.deploy(overrides || {}) as Promise<BusinessLogicV1>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BusinessLogicV1 {
    return super.attach(address) as BusinessLogicV1;
  }
  connect(signer: Signer): BusinessLogicV1__factory {
    return super.connect(signer) as BusinessLogicV1__factory;
  }
  static readonly contractName: "BusinessLogicV1";
  public readonly contractName: "BusinessLogicV1";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BusinessLogicV1Interface {
    return new utils.Interface(_abi) as BusinessLogicV1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BusinessLogicV1 {
    return new Contract(address, _abi, signerOrProvider) as BusinessLogicV1;
  }
}
